import React from "react";
import "../styles/MoreOptionsPane.css";

const MoreOptionsPane = ({ options, onClose }) => {
  return (
    <div className="more-options-pane">
      {options.map((option, index) => (
        <button key={index} onClick={option.action}>
          {option.label}
        </button>
      ))}
      <button onClick={onClose}>Close</button>
    </div>
  );
};

export default MoreOptionsPane;
